// src/components/QuickPairModal.jsx
// 보유종목 옆 버튼 → 앵커 종목 고정, 반대 포지션 종목 선택 → 즉시 롱숏 스프레드 차트.
import React, { useMemo, useState } from "react";
import { usePairData, pairId } from "../hooks/usePairData";
import PairSpreadCard from "./PairSpreadCard";
import StockPicker from "./StockPicker";

const RANGES = [["6mo", "6개월"], ["1y", "1년"], ["3y", "3년"], ["5y", "5년"]];

// anchor: { ticker, name, market, short }  — short이면 앵커가 숏 레그, 반대편은 롱.
export default function QuickPairModal({ anchor, onClose, onSavePair }) {
  const [counter, setCounter] = useState(null);   // 반대편 {n,c,m}
  const [range, setRange] = useState("3y");

  const pair = useMemo(() => {
    if (!counter) return null;
    const A = { t: String(anchor.ticker), n: anchor.name || String(anchor.ticker), m: anchor.market || "KR" };
    const C = { t: counter.c, n: counter.n, m: counter.m === "KR" ? "KR" : counter.m };
    const [L, S] = anchor.short ? [C, A] : [A, C];   // 앵커가 숏이면 반대편이 롱
    return {
      longTicker: L.t, longName: L.n, longMarket: L.m,
      shortTicker: S.t, shortName: S.n, shortMarket: S.m,
    };
  }, [counter, anchor]);

  const pairsArr = useMemo(() => (pair ? [pair] : []), [pair]);
  const { data, loading } = usePairData(pairsArr, range);
  const result = pair ? data[pairId(pair)] : null;

  const oppLabel = anchor.short ? "🔺 롱(매수) 종목 추가" : "🔻 숏(매도) 종목 추가";

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 16 }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background: "#fff", borderRadius: 16, width: "min(680px, 96vw)", maxHeight: "92vh", overflowY: "auto", boxShadow: "0 8px 40px rgba(0,0,0,0.15)" }}>
        <div style={{ padding: "16px 22px", borderBottom: "1px solid #f0f0f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>
            롱숏 페어 —{" "}
            <span style={{ color: anchor.short ? "#c0392b" : "#0a7c59" }}>
              {anchor.short ? "숏" : "롱"} {anchor.name}
            </span>
          </h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: "#aaa" }}>✕</button>
        </div>

        <div style={{ padding: 22, display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <label style={{ fontSize: 12, color: "#888", display: "block", marginBottom: 5 }}>{oppLabel}</label>
            <StockPicker value={counter} onPick={setCounter} onClear={() => setCounter(null)} />
          </div>

          {!pair && (
            <div style={{ padding: "20px", textAlign: "center", color: "#aaa", fontSize: 13, background: "#f7f8fa", borderRadius: 10 }}>
              반대 포지션 종목을 선택하면 스프레드 차트가 나옵니다.
            </div>
          )}

          {pair && (
            <>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ display: "flex", border: "1px solid #e2e2e2", borderRadius: 8, overflow: "hidden" }}>
                  {RANGES.map(([v, lab]) => (
                    <button key={v} onClick={() => setRange(v)}
                      style={{ padding: "6px 12px", border: "none", cursor: "pointer", fontSize: 12, fontWeight: 700, background: range === v ? "#1a1a2e" : "#fff", color: range === v ? "#fff" : "#888" }}>{lab}</button>
                  ))}
                </div>
                {onSavePair && (
                  <button onClick={() => onSavePair(pair)}
                    style={{ padding: "6px 14px", borderRadius: 8, border: "1px solid #0a7c59", background: "#fff", color: "#0a7c59", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                    + 차트북에 저장
                  </button>
                )}
              </div>

              {loading && !result ? (
                <div style={{ padding: 30, textAlign: "center", color: "#888" }}>📊 스프레드 계산 중…</div>
              ) : result ? (
                <PairSpreadCard pair={pair} result={result} onDelete={() => {}} />
              ) : (
                <div style={{ padding: 20, textAlign: "center", color: "#c0392b", fontSize: 13 }}>
                  시세를 못 받았어요 — 시장(코스피/코스닥)을 바꿔보세요.
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
